import React from 'react';
import './modal-my-content.styles.scss';
import Modal from '@/components/modal/modal.component';
import ContentManager from './content-manager.component';

const ModalMyContent = ({
    show,
    cancel,
    chooseElement,
    type
}) => {
    return (
        <div className='modal-my-content'>
            <Modal
                show={show}
                cancel={cancel}
                text='Your Content'
                closeButton={true}
                cls='full' >
                <ContentManager
                    element={type}
                    chooseElement={chooseElement} />
            </Modal>
        </div>
    )
}

export default ModalMyContent